import moment from "moment";

export const dateFormats = {
    localFormatLong: "DD-MM-YYYY HH:mm",
    apiFormat: "YYYY-MM-DD HH:mm",
};

const formatDateTime = (utcDate, dateFormat) => {
    if (utcDate) {
        
        return moment(utcDate).local().format(dateFormat);
    }
    return null;
};

const isoDate = (date) => {
    return new Date(date).toISOString();
};

const compareDate = (date1, date2) => {
    date1 = moment(date1);
    date2 = moment(date2);
    const duration = moment.duration(date1.diff(date2));
    return duration.asSeconds();
};

const formatDate = (date) => {
    let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
};

const checkDate = (date) => {
    date = formatDate(date);

    return moment().isAfter(date, "hour");
};
const formatTimeToGmt = (date, num) => {
    let Startmin = null;
    let Starthrs = null;
    let Endmin = null;
    let Endhrs = null;
    //GET THE HOURS  AND THEN CHECK IF IT LESS THAN 10 AND APPEND "0" TO IT
    if (num === 1) {
        if (new Date(date).getHours() < 10) {
            Starthrs = "0" + new Date(date).getHours();
        } else {
            Starthrs = new Date(date).getHours();
        }

        if (new Date(date).getMinutes() < 10) {
            Startmin = "0" + new Date(date).getMinutes();
        } else {
            Startmin = new Date(date).getMinutes();
        }

        return { Startmin, Starthrs };
    }
    if (num === 2) {
        if (new Date(date).getHours() < 10) {
            Endhrs = "0" + new Date(date).getHours();
        } else {
            Endhrs = new Date(date).getHours();
        }

        if (new Date(date).getMinutes() < 10) {
            Endmin = "0" + new Date(date).getMinutes();
        } else {
            Endmin = new Date(date).getMinutes();
        }

        return { Endmin, Endhrs };
    }
};

const formatStringToGmt = (date, num) => {
    let startTime = null;
    let endTime = null;

    if (num === 1) {
        if (date.length === 5) {
            startTime = date;
            return { startTime };
        } else {
            startTime = "0" + date;
            return { startTime };
        }
    }
    if (num === 2) {
        if (date.length === 5) {
            endTime = date;
            return { endTime };
        } else {
            endTime = "0" + date;
            return { endTime };
        }
    }
};
const AmPmChecker = (time) => {
    let checker = 0;
    let formatTime = undefined;
    if (time.length === 5) {
        checker = Number(time.slice(0, 2));
        if (checker <= 12) {
            return `${time} AM`;
        } else {
            return `${time} PM`;
        }
    }
    if (time.length === 4) {
        formatTime = "0" + time;
        checker = Number(formatTime.slice(0, 2));
        if (checker <= 12) {
            return `${time} AM`;
        } else {
            return `${time} PM`;
        }
    }
};
const ConvertToUtc = (date) => {
    return moment(date).utcOffset("-00:00").format();
};
export const dateTimeutils = {
    formatDateTime,
    isoDate,
    compareDate,
    formatTimeToGmt,
    formatStringToGmt,
    AmPmChecker,
    checkDate,
    ConvertToUtc,
};
